import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Welcome.css';

export default class Welcome extends Component {
  static propTypes = {
    name: PropTypes.string
  }

  render() {
    return (
      <div className="Welcome">
        <h3>Hello, {this.props.name}!</h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WelcomeComponent/Welcome.js